/**
 * Token used in "Good morning, {name}".
 * Role-like display names whose last standalone word is "Admin"
 * greet as "Admin"; ordinary names keep their first word.
 */
export function greetingName(input: string): string {
  const cleaned = input.split("@")[0]!;
  const words = cleaned.split(/[\s._-]/).filter(Boolean);
  const last = words.at(-1);
  if (last?.toLowerCase() === "admin") return "Admin";
  const word = words[0] ?? cleaned;
  return word.charAt(0).toUpperCase() + word.slice(1);
}
